export default __webpack_public_path__ + "static/media/3.f9562cf3.png";